export enum TestIds {
  AppetiteType = 'AppetiteType',
  Impact = 'Impact',
  LikelihoodAppetite = 'LikelihoodAppetite',
  UpperAppetite = 'UpperAppetite',
}
